import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeMap = {
  sm: 16,
  md: 24,
  lg: 40,
};

export default function LoadingSpinner({ size = 'md', label }: LoadingSpinnerProps) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3"
      role="status"
      aria-live="polite"
    >
      <Loader2
        size={sizeMap[size]}
        className="animate-spin text-brand-700 dark:text-brand-400"
        aria-hidden="true"
      />
      {label && <p className="text-sm text-slate-700 dark:text-slate-400">{label}</p>}
      <span className="sr-only">
        {label || 'Loading'}
      </span>
    </div>
  );
}